import { Fade, makeStyles, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from '../ClaimWizard';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import { separations } from '../../../../constants/StyleConstants';
import PurchaseOrders from '../../../PurchaseOrders/PurchaseOrders';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
}));

const PurchaseOrdersSelection = ({ setPurchaseOrder }) => {
  const classes = useStyles();
  const { setStepElements, stepForward } = useContext(ClaimContext);
  const [transIn, setTransIn] = useState(true);

  useEffect(() => {
    const step = {
      stepNumber: 1,
      backButtonText: 'Cancelar y elegir otro tipo de reclamo',
      nextButtonText: 'Reclamo por Perdido de Compra Inexistente',
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);
    setPurchaseOrder(null);
  }, []);

  const handleSelection = (event, rowData) => {
    setPurchaseOrder(rowData);
    stepForward();
  };

  return (
    <Fade in={transIn} timeout={transitionTimeout} unmountOnExit>
      <div className={classes.root}>
        <Typography className={classes.bottomSeparation} variant="subtitle2">
          Seleccione un pedido de compra haciendo click en la fila correspondiente
        </Typography>
        <PurchaseOrders fullResponsive onRowClick={handleSelection} />
      </div>
    </Fade>
  );
};

export default PurchaseOrdersSelection;
